import React from 'react';
import SubNavigationCollapsible from './SubNavigationCollapsible';
import { SubNavigationLinkModel } from '../../Types/SubNavigationLinkModel';
import clsx from 'clsx';

const SubNavigation = ({ links, name, url }: SubNavigationLinkModel) => {
  return (
    <ul className="rounded-b border-t border-gray-300 md:rounded md:border [&_.collapsible]:!border-b-0 [&_.collapsible]:!border-t-0">
      <li className="border-gray-300 [&:not(:last-child)]:border-b">
        <a
          className="flex h-10 items-center pl-2 text-md font-bold hover:bg-gray-100"
          href={url}
        >
          {name}
        </a>
      </li>
      {links?.length >= 1 && (
        <ul
          className={clsx(
            'border-gray-300 [&_>li:not(:last-child)]:border-b'
          )}
        >
          {links.map((link, idx) =>
            link.links?.length >= 1 ? (
              <li
                className={clsx(
                  'border-b-0',
                  link.isSelected && 'bg-gray-100'
                )}
                key={link.name + link.url + idx}
              >
                <SubNavigationCollapsible
                  isOpen={
                    link.isSelected ||
                    link.links.some((l) => l.isSelected == true)
                  }
                  label={
                    <a
                      className={clsx(
                        'flex h-10 items-center pl-4 text-md hover:bg-gray-100',
                        link.isSelected && 'font-bold'
                      )}
                      href={link.url}
                    >
                      {link.name}
                    </a>
                  }
                >
                  <ul>
                    {link.links.map((secondLevelLink, idx) => (
                      <li
                        className={clsx(
                          'border-b-0',
                          secondLevelLink.isSelected && 'bg-gray-100'
                        )}
                        key={secondLevelLink.name + idx}
                      >
                        <a
                          className={clsx(
                            'flex h-10 items-center !text-md hover:bg-gray-100',
                            secondLevelLink.isSelected && 'font-bold'
                          )}
                          href={secondLevelLink.url}
                        >
                          {secondLevelLink.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </SubNavigationCollapsible>
              </li>
            ) : (
              <li
                className={clsx(link.isSelected && 'bg-gray-100')}
                key={link.name + idx}
              >
                <a
                  className={clsx(
                    'flex h-10 items-center pl-4 text-md hover:bg-gray-100',
                    link.isSelected && 'font-bold'
                  )}
                  href={link.url}
                >
                  {link.name}
                </a>
              </li>
            )
          )}
        </ul>
      )}
    </ul>
  );
};

export default SubNavigation;
